import cn from 'classnames';
import { UseFormRegister } from 'react-hook-form';
import AlertIcon from 'shared/icons/alert.svg';
import { FormValues } from '../types';
import styles from './questionnaire-form-footer.module.scss';

type QuestionnaireFormFooterProps = {
  error: boolean;
  register: UseFormRegister<FormValues>;
  toggleAgreementDrawer: () => void;
};

export const QuestionnaireFormFooter = ({ error, register, toggleAgreementDrawer }: QuestionnaireFormFooterProps) => {
  const handleClick: React.MouseEventHandler<HTMLSpanElement> = (e) => {
    e.preventDefault();
    toggleAgreementDrawer();
  };

  return (
    <div className={styles.footer}>
      <div className={cn(styles.errorMessage, { [styles.errorMessage__visible]: error })}>
        <img src={AlertIcon} alt="" width={20} height={20} style={{ flexShrink: 0 }} />
        Для отправки анкеты необходимо заполнить поля и дать согласие на обработку данных
      </div>
      <div className={styles.submitSection}>
        <div className={styles.checkbox}>
          <input
            tabIndex={17}
            type="checkbox"
            id="checkbox-consent"
            className={styles.box}
            {...register('personalDataConsent')}
          />
          <label className={styles.label} htmlFor="checkbox-consent">
            Даю{' '}
            <span className={styles.agreementLink} onClick={handleClick}>
              согласие
            </span>{' '}
            на обработку моих персональных данных
          </label>
        </div>
        <button className={styles.submitButton} tabIndex={18} type="submit">
          Отправить
        </button>
      </div>
    </div>
  );
};
